// extracted by css-extract-rspack-plugin
export default {"checkboxRoot":"A_aisd","checkboxIndicator":"vXKzI5","checkboxCheck":"QmSskq"};